import axios from 'axios'
import { host } from '../config'

const matutinas = axios.create({ baseURL: `${host}/matutinas` })
const pensamientos = axios.create({ baseURL: `${host}/pensamientos` })
const programas = axios.create({ baseURL: `${host}/programas` })
const auth = axios.create({ baseURL: `${host}/auth` })
const libros = axios.create({ baseURL: `${host}/libros` })
const notificaciones = axios.create({ baseURL: `${host}/notificacions` })
const sugerencias = axios.create({ baseURL: `${host}/sugerencias` })
const oraciones = axios.create({ baseURL: `${host}/oracions` })
const videos = axios.create({ baseURL: `${host}/videos` })
const fotos = axios.create({ baseURL: `${host}/fotos` })
const slides = axios.create({ baseURL: `${host}/slides` })
const mensajes = axios.create({ baseURL: `${host}/mensajes` })
const hashtags = axios.create({ baseURL: `${host}/hashtags` })
const igposts = axios.create({ baseURL: `${host}/igposts` })
const encuestas = axios.create({ baseURL: `${host}/encuestas` })
const preguntas = axios.create({ baseURL: `${host}/preguntas` })
const opciones = axios.create({ baseURL: `${host}/opcions` })
const excel = axios.create({ baseURL: host, responseType: 'blob' })

const services = {
  $http: {
    get () {
      return {
        auth,
        libros,
        matutinas,
        pensamientos,
        programas,
        notificaciones,
        sugerencias,
        oraciones,
        videos,
        fotos,
        slides,
        mensajes,
        hashtags,
        igposts,
        encuestas,
        preguntas,
        opciones,
        excel
      }
    },
    post () {
      return {
        auth,
        libros,
        matutinas,
        pensamientos,
        programas,
        notificaciones,
        videos,
        fotos,
        slides,
        mensajes,
        hashtags,
        igposts,
        encuestas,
        preguntas,
        opciones
      }
    },
    put () {
      return {
        auth,
        libros,
        matutinas,
        pensamientos,
        programas,
        oraciones,
        slides,
        mensajes,
        encuestas,
        preguntas,
        opciones
      }
    },
    delete () {
      return {
        auth,
        libros,
        matutinas,
        pensamientos,
        programas,
        notificaciones,
        sugerencias,
        oraciones,
        videos,
        fotos,
        slides,
        mensajes,
        hashtags,
        igposts,
        encuestas,
        preguntas,
        opciones
      }
    }
  }
}

export default (Vue) => {
  Object.defineProperties(Vue.prototype, services)
}
